import type { TypeCCDistributionAction } from 'types/actionPlan';
import { useTranslation } from 'react-i18next';
import useApp from 'hooks/useApp';
import { getCostCentreDescription } from 'hooks/useGrid/gridFunctions';
import { getShortCC } from 'utils/text';
import Text from '@ingka/text';
import classes from '../ActionTable.module.scss';

const CCDistributionAction = ({ action }:{ action: TypeCCDistributionAction }) => {
    const { t } = useTranslation();
    const { orgSelection: { utils: { hierarchy } } } = useApp();
    const { ccDistributions } = action;

    return (
        <div className={classes['details-changes']}>
            <div className={classes['details-changes-container']}>
                <Text tagName="span" textStyle="Heading.S" data-testid="action-plan-cost-distribution-header">
                    {t('actionPlan.table.cost_center_distribution')}
                </Text>
                {ccDistributions.map(cc => (
                    <Text className={classes['details-changes__cc-distribution']} key={cc.to.costCentre} data-testid="action-plan-cost-distribution-change">
                        {getCostCentreDescription(cc.from.costCentre, hierarchy?.costCentreHierarchy)}
                        {' '}
                        {`CC${getShortCC(cc.from.costCentre)}`}
                        <b>
                            {` (${cc.from.hours} ${t('globals.labels.hours_abbreviated')}) ➔ `}
                        </b>
                        {getCostCentreDescription(cc.to.costCentre, hierarchy?.costCentreHierarchy)}
                        {' '}
                        {`CC${getShortCC(cc.to.costCentre)}`}
                        <b>
                            {' '}
                            {`(${cc.to.hours} ${t('globals.labels.hours_abbreviated')})`}
                        </b>
                    </Text>
                ))}

            </div>
        </div>
    );
};

export default CCDistributionAction;
